import React from 'react';
import { useNavigate } from 'react-router-dom';
const DonationMarquee: React.FC = () => {
  const navigate = useNavigate();
  const handleLearnMore = () => {
    navigate('/donations');
  };
  return <div className="bg-indigo-600 text-white py-2 overflow-hidden" data-id="element-3724" data-mp="mqbkc79xt0ha">
      <div className="animate-marquee whitespace-nowrap inline-flex items-center" data-id="element-3725" data-mp="ms66tq0ux0nh">
        <span className="text-sm font-medium mx-4" data-id="element-3726" data-mp="rqzj5f4eqlm2">
          Support independent authors and bookstores! A portion of every
          purchase goes to literacy programs.
        </span>
        <button onClick={handleLearnMore} className="mx-4 px-3 py-1 bg-white text-indigo-600 text-xs font-bold rounded-full hover:bg-indigo-100 focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-indigo-600 flex-shrink-0" data-id="element-3727" data-mp="hs07dnoci9uu">
          Learn More
        </button>
        <span className="text-sm font-medium mx-4" aria-hidden="true" data-id="element-3728" data-mp="3q8v2ggywipyd">
          Support independent authors and bookstores! A portion of every
          purchase goes to literacy programs.
        </span>
        <button onClick={handleLearnMore} className="mx-4 px-3 py-1 bg-white text-indigo-600 text-xs font-bold rounded-full hover:bg-indigo-100 focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-indigo-600 flex-shrink-0" aria-hidden="true" tabIndex={-1} data-id="element-3729" data-mp="1s13psb5wfqmi">
          Learn More
        </button>
      </div>
    </div>;
};
export default DonationMarquee;